import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import BrandSelection from '/@/components/brand-selection';
import PrivacyBar from '/@/components/privacy-bar';
import PrivacyDisclaimer from '/@/components/privacy-disclaimer';
import { _ } from '/@/locale';
import { useProductDatasheetConfig } from '/@/store/product-datasheet/apiProviders';
import { getProductDatasheetBrands } from '/@/store/product-datasheet/selectors';
import { reverse } from '/@/utils/router';

const ProductDatasheetBrandSelection = (props) => {
    const navigate = useNavigate();

    const productDatasheetConfigsQuery = useProductDatasheetConfig({ page: 1, pageSize: 10000 });
    const brands = useSelector((state) =>
        getProductDatasheetBrands(state, productDatasheetConfigsQuery.data?.results || []).sort(
            (a, b) => a.order - b.order
        )
    );

    const handleClick = (type, slug) => {
        navigate(reverse('productDatasheet.ProductDatasheetProductsConfiguration', { params: { type, slug } }));
    };

    return (
        <div>
            <PrivacyBar />
            <PrivacyDisclaimer crop={Math.random() > 0.5 ? 'soy' : 'corn'} />
            <BrandSelection
                title={_('Ficha técnica de producto')}
                subtitle={_('Seleccioná la marca para configurar tu ficha técnica de producto.')}
                brands={brands}
                onClick={handleClick}
                warning={_('Por favor no compartir con terceros.')}
            />
        </div>
    );
};

export default ProductDatasheetBrandSelection;
